<template>
  <div>
    <a-form-item label="Select permissions for your role">
    <!-- <a-checkbox-group class="ucheck" v-decorator="['permissions']" > v-model="permissiondata" @change="informparent"> -->
    <a-checkbox-group class="ucheck" v-model="permissiondata" @change="informparent">
    <a-collapse>
        <a-collapse-panel v-for="(perm,index) in this.data" :key="index" :header="perm.module_name">
          <a-checkbox  @change="onCheckAllChange(perm,$event)"  :value="'module_id_'+ perm.module_id">
            Check all
          </a-checkbox>
            <table>
                <tbody>
                    <tr v-for="(pdata, index) in (perm.submodules)" :key="index">
                      <td>
                        <div style="display:inline-block;" v-for="(permdata, index) in (pdata.permissions)" :key="index">
                          <a-checkbox :value="permdata.id" @change="handleCheckBoxOnChange(permdata.id,$event)">
                              {{permdata.name}}
                          </a-checkbox>
                        </div>

                      </td>
                    </tr>
                </tbody>
            </table>
        </a-collapse-panel>
    </a-collapse>
    </a-checkbox-group>
    </a-form-item>
  </div>
</template>

<script>
export default {
  name: 'PermissionElement',
  props: {
    data: { type: Array, required: true },
    userselected: { type: Array },
    // type: { type: String, required: true },
  },
  data: function() {
    return {
      permissiondata: [],
      checkboxstate: false,
    }
  },
  methods: {
    informparent: function() {
      console.log('Inside informparent:: ', this.permissiondata)
      this.$emit('onCheckAPermission', this.permissiondata)
    },
    ischecked: function () {
      return false
    },
    handleCheckBoxOnChange: function (permissionId, event) {
      if (event.target.checked) {
        this.permissiondata.push(permissionId)
      } else {
        let index = this.permissiondata.indexOf(permissionId)
        this.permissiondata.splice(index, 1)
      }
      console.log('permissiondata After ::', this.permissiondata)
    },
    onCheckAllChange(modulePermissions, event) {
      const modulePermissionIds = []
      for (const submodule of modulePermissions.submodules) {
        for (const permission of submodule.permissions) {
          modulePermissionIds.push(permission.id)
        }
      }
      console.log('modulePermissionIds:: ', modulePermissionIds)
      if (event.target.checked) {
        console.log('All Checkbox is checked')
        // this.permissiondata.push(permissionId)
        for (const permissionId of modulePermissionIds) {
          if (!this.permissiondata.includes(permissionId)) {
            this.permissiondata.push(permissionId)
          }
        }
        this.permissiondata.push('module_id_' + modulePermissions.module_id)
        console.log('All Checkbox is checked: ', this.permissiondata)
      } else {
        for (const value of modulePermissionIds) {
          const index = this.permissiondata.indexOf(value)
          if (index !== -1) {
            this.permissiondata.splice(index, 1)
          }
        }
        const moduleIdIndex = this.permissiondata.indexOf('module_id_' + modulePermissions.module_id)
        this.permissiondata.splice(moduleIdIndex, 1)
        console.log('All Checkbox is not checked', this.permissiondata)
      }
    },

  },
  watch: {
    userselected(nvalue, ovalue) {
      console.log('inside component...')
      console.log('newvalue ', nvalue)
      console.log('oldvalue ', ovalue)

      this.permissiondata = nvalue
      console.log('userselected permissions ', this.permissiondata)
    },
  },
  mounted: function() {
    // this.permissiondata = this.userselected
    // this.permissiondata.length = 0
  },
}
</script>

<style>
.ucheck {
    width: 100%;
}
</style>
